import { Map } from "immutable";
import { getTokenLocal } from "../../helpers/auth/utils";
import actions from "./actions";

const initState = new Map({
  access_token: null,
  refresh_token: null,
  token_valid: false,
  loginError: false,
	login_failed: false,
	login_failed_message: "",
	login_working: false,
  registration_working: false,
  registration_data: null,
});

export default function authReducer(
	state = initState.merge(getTokenLocal()),	action) {
	switch (action.type) {

		case "USER_REGISTER":
			return state
				.set("registration_working", true)
				.set("registration_data", null)
		case "USER_REGISTER_SUCCESS":
			return state
				.set("registration_working", false)
				.set("registration_data", {...action.data})
		case "USER_REGISTER_FAILED":
			return state
				.set("registration_data", null)
				.set("registration_working", false)

		case actions.USER_LOGIN:
			return state
				.set("access_token", null)
				.set("refresh_token", null)
				.set("loginError", false)
				.set("login_failed", false)
				.set("login_failed_message", "")
				.set("login_working", true)
		case actions.USER_LOGIN_SUCCESS:
			return state
				.set("access_token", action.data?.data?.access_token)
        .set("refresh_token", action.data?.data?.refresh_token)
				.set("loginError", false)
				.set("login_failed", false)
				.set("login_failed_message", "")
				.set("login_working", false)
		case actions.USER_LOGIN_ERROR:
			return state
				.set("access_token", null)
				.set("refresh_token", null)
				.set("loginError", true)
				.set("login_failed", true)
				.set("login_failed_message", action.data?.data?.error)
				.set("login_working", false)

		case actions.USER_LOGOUT:
			return initState;

		case actions.USER_REFRESH_TOKEN_SUCCESS:
			return state
				.set("access_token", action.data?.data?.access_token)
        .set("token_valid", true)
    case actions.REFRESH_TOKEN_ERROR:
      return state.set("token_valid", false)

		case actions.USER_REFRESH_TOKEN_LOCAL:
			const token = getTokenLocal();
			return state
				.set("access_token", token.access_token)
				.set("refresh_token", token.refresh_token)
        .set("token_valid", true)

		default:
			return state;
  }
}
